/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import ADGMImage from '../../../ADGMImage';
import styles from './styles';

function UploadDocument(props) {
  const { classes, title, documentType, mandatory, documents, uploadLimit, onUpload, onRemove } = props;

  const handleUpload = e => {
    const { name, files } = e.target;
    if (!files[0]) return;
    onUpload && onUpload(name, files[0]);
  };

  const handleFileRemove = subType => {
    onRemove && onRemove(documentType, subType);
  };

  return (
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classNames(classes.accordionTitleHead)}>
        <ADGMImage name='DocumentBlack.svg' alt='document' />
        <Typography component='p'>
          {messages[title]?.id ? <FormattedMessage {...messages[title]} /> : title}
          {mandatory && <span className={classes.mandatory}>*</span>}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        {!isEmpty(documents) && (
          <div className={classes.docsFlexContainer}>
            {(documents || []).map(file => (
              <div key={file.id} className={classNames(classes.fileFlex)}>
                <ADGMImage name='PDF.svg' alt='pdf' />
                <Typography component='p'>{file.fileName}</Typography>
                <Button onClick={() => handleFileRemove(file.subType)}>
                  <FormattedMessage {...messages.remove} />
                </Button>
              </div>
            ))}
          </div>
        )}
        {(documents || []).length < uploadLimit && (
          <div className={classes.buttonContainer}>
            <input
              id={documentType}
              name={documentType}
              type='file'
              accept='application/pdf'
              multiple
              hidden
              onChange={handleUpload}
            />
            <label htmlFor={documentType}>
              <Button variant='outlined' component='span' className={classes.button}>
                <ADGMImage name='uplaodIcon.svg' alt='icon' />
                <Typography component='p'>
                  <FormattedMessage {...messages.upload_document} />
                </Typography>
              </Button>
            </label>
          </div>
        )}
      </AccordionDetails>
    </Accordion>
  );
}

UploadDocument.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  documentType: PropTypes.string.isRequired,
  mandatory: PropTypes.bool,
  documents: PropTypes.array,
  uploadLimit: PropTypes.number,
  onUpload: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

UploadDocument.defaultProps = {
  mandatory: false,
  documents: [],
  uploadLimit: 5,
};

export default withStyles(styles)(UploadDocument);
